module.exports = __webpack_public_path__ + "assets/retina_CleaverDetailed.ad51200ab8ece4af4a1d800b86ec309e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CleaverDetailed.png
// module id = 652
// module chunks = 0